import {
  Button,
  Dialog,
  DialogContent,
  DialogHeader,
  DialogOverlay,
  DialogPortal,
  DialogTitle,
  ScrollArea,
} from "@devhop/ui";
import {
  usePrivateLessonBookingQuery,
  useUpdatePrivateLessonBooking,
} from "../api/queries";
import { BookingEditForm } from "./BookingEditForm";

type EditPrivateBookingDialogProps = {
  bookingId: string | null;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onSuccess?: () => void;
};

export function EditPrivateBookingDialog({
  bookingId,
  open,
  onOpenChange,
  onSuccess,
}: EditPrivateBookingDialogProps) {
  const { data: booking, isLoading } = usePrivateLessonBookingQuery(
    bookingId ?? "",
  );
  const updateBooking = useUpdatePrivateLessonBooking();

  const canEdit =
    booking && booking.status !== "completed" && booking.status !== "cancelled";

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogPortal>
        <DialogOverlay />
        <DialogContent
          className="!max-w-[min(95vw,1200px)] max-h-[90vh] overflow-hidden p-0"
          showCloseButton
        >
          <DialogHeader className="border-b px-6 py-4">
            <DialogTitle>ແກ້ໄຂການຈອງຮຽນສ່ວນຕົວ</DialogTitle>
          </DialogHeader>
          {isLoading || !booking ? (
            <div className="px-6 py-8 text-center text-muted-foreground">
              ກຳລັງໂຫຼດ...
            </div>
          ) : !canEdit ? (
            <div className="space-y-4 px-6 py-4">
              <p className="text-muted-foreground">
                ບໍ່ສາມາດແກ້ໄຂການຈອງທີ່ສຳເລັດຫຼືຍົກເລີກແລ້ວ
              </p>
              <div className="flex justify-end">
                <Button variant="outline" onClick={() => onOpenChange(false)}>
                  ປິດ
                </Button>
              </div>
            </div>
          ) : (
            <ScrollArea className="max-h-[calc(90vh-4rem)] overflow-auto px-6 pb-6">
              <BookingEditForm
                initialValues={booking}
                onSubmit={async (vals) => {
                  try {
                    await updateBooking.mutateAsync({
                      id: booking.id,
                      input: vals,
                    });
                    onSuccess?.();
                    onOpenChange(false);
                  } catch {
                    // Error handled by mutation
                  }
                }}
                submitting={updateBooking.isPending}
              />
            </ScrollArea>
          )}
        </DialogContent>
      </DialogPortal>
    </Dialog>
  );
}
